import { render, staticRenderFns } from "./BusinessBrand.vue?vue&type=template&id=f54ee80e&scoped=true"
import script from "./BusinessBrand.vue?vue&type=script&lang=js"
export * from "./BusinessBrand.vue?vue&type=script&lang=js"
import style0 from "./BusinessBrand.vue?vue&type=style&index=0&id=f54ee80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54ee80e",
  null
  
)

export default component.exports